import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../store/auth/auth.state';

@Pipe({
  name: 'fullName',
  standalone: true,
})
export class FullNamePipe implements PipeTransform {
  transform(user: User | null): string {
    if (!user) return 'Anonymous User';

    return user.fullName;
  }
}
